const style = {
  container: {
    padding: 0
  },
  wrapper: {
    borderBottom: `2px solid #2B2B2B`,
    height: `300px`,
    padding: `0 20px`
  },
  innerWrapper: {
    height: `100%`
  },
  h4: {
    color: `#a2a2a2`,
    fontSize: `14px`,
    fontWeight: 600,
    marginBottom: `24px`
  },
  link: {
    fontSize: `14px`,
    color: `#a2a2a2`
  },
  company: {
    padding: `20px`,
    background: `#2B2B2B`,
    height: `100%`
  },
  logo: {
    height: `50px`,
    width: `150px`
  },
  address: {
    padding: `20px 0`,
    margin: 0,
    textAlign: `center`,
    color: `#777779`,
    fontSize: `14px`
  },
  email: {
    fontSize: `14px`,
    color: `#A94545`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/partials/Footer/style/top.js